<!-- Logo -->
<div class="logo">
  <img src="assets/images/logos/dashboard-logo-1.svg" width="35" height="35" />
  <p class="title-text">LongTail Dashboard</p>
</div>

<div class="container">
  <div class="lottie-container">
    <!-- <ng-lottie width="400px" [options]="animationOptions"></ng-lottie> -->
  </div>

  <div class="error">
    <h1>{{ 'errors.not-found.not-found' | translate }}</h1>
    <p>
      {{ 'errors.not-found.info-message' | translate }}
    </p>
    <a href="javascript:void(0);" (click)="navigateToPrevious();" class="back-button">{{ 'errors.not-found.back-to-home'
      | translate }}</a>
  </div>


</div>